<template>
    <div
        class="modal"
        :id="compModalIdentifier"
        tabindex="-1"
    >
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        {{ isEdit ? 'Edit' : 'Create' }} Expense
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light">
                    <fieldset>

                        <div class="row" v-if="isEdit && expense?.driver">
                            <div class="col-12">
                                <AdminBlock>
                                    <p class="mb-0">
                                        <strong>
                                            Driver:
                                        </strong>
                                        <a :href="driverLink">
                                          {{ expense.driver ? expense.driver.name : 'N/A' }}
                                        </a>
                                    </p>
                                </AdminBlock>
                            </div>
                        </div>

                        <div class="row" v-else>
                            <div class="col-12">
                                <AdminBlock>
                                    <MovementSelect
                                        v-model="selectedMovement"
                                        :movement="movements[0]"
                                        :job="job"
                                        remove-margin
                                        required
                                    />
                                </AdminBlock>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <AdminBlock
                                    title="Expense"
                                >

                                    <InputTextField
                                        name="Label"
                                        label="Label"
                                        placeholder="Label"
                                        required
                                        v-model="expenseLabel"
                                    />

                                    <InputTextField
                                        name="reference"
                                        label="Reference (Optional)"
                                        placeholder="Reference"
                                        v-model="reference"
                                    />

                                    <InputNumberField
                                        name="fuel"
                                        label="Fuel (Optional)"
                                        placeholder="Fuel"
                                        append="Litres"
                                        v-model="fuel"
                                    />

                                    <div class="">
                                        <div class="mb-2">
                                            <input
                                                v-model="evidenceReceived"
                                                class="me-2"
                                                type="checkbox"
                                                name="evidence_received"
                                                :id="evidenceReceivedId"
                                            />
                                            <label :for="evidenceReceivedId">
                                                <strong>
                                                    Evidence Received (If assigned to Driver)
                                                </strong>
                                            </label>
                                        </div>

                                        <div>
                                            <input
                                                v-model="rechargeClient"
                                                class="me-2"
                                                type="checkbox"
                                                name="recharge_client"
                                                :id="rechargeClientId"
                                            />
                                            <label :for="rechargeClientId">
                                                <strong>
                                                    Recharge Client
                                                </strong>
                                            </label>
                                        </div>
                                    </div>

                                </AdminBlock>

                                <AdminBlock
                                    title="Driver"
                                    class="mb-0"
                                >
                                    <p>
                                        If the Expense was incurred by a Driver and needs paying back to them, please select them below.
                                    </p>
                                    <DriverSelect
                                        :driver="selectedDriver"
                                        required
                                        remove-margin
                                        @update-driver="updateDriver"
                                    />
                                </AdminBlock>
                            </div>

                            <div class="col-lg-6">
                                <AdminBlock
                                    title="Cost"
                                >
                                    <div class="mb-4">
                                        <label for="">
                                            <strong>
                                                Payment Method
                                            </strong>
                                            <span class="text-danger">*</span>
                                        </label>

                                        <VSelect
                                            v-model="selectedPaymentMethod"
                                            :options="[
                                                'Cash',
                                                'Card',
                                                'By Admin'
                                            ]"
                                            placeholder="Payment Method"
                                            required
                                        />
                                    </div>

                                    <p>
                                        If you complete the Total and either the Price or VAT, the remaining field will be automatically filled.
                                    </p>

                                    <InputTextField
                                        name="price"
                                        label="Price (Optional)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="price"
                                    />

                                    <InputTextField
                                        name="vat"
                                        label="VAT Amount (Optional)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="vat"
                                    />

                                    <InputTextField
                                        name="total"
                                        label="Total (Optional if fuel)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="total"
                                        remove-margin
                                    />

                                </AdminBlock>

                                <AdminBlock
                                    title="Images"
                                    class="mb-0"
                                >

                                    <p class="mb-0">
                                        Please upload your receipts where possible
                                    </p>

                                    <FileUpload
                                        :file-upload-route="getFileUploadRoute()"
                                        name="receipt_file_signature"
                                        ref="fileUpload"
                                        no-margin
                                        multiple
                                        @file-uploaded="handleFileUploaded"
                                    />

                                </AdminBlock>
                            </div>
                        </div>

                        <template v-if="files.length > 0">
                            <AdminBlock class="mb-2 mt-4"  :title="'File' + (files.length > 1 ? 's' : '')">
                                <table class="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th style="width: 115px;">Date</th>
                                            <th style="width: 150px;">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="file in files" :key="file.id">
                                            <td class="align-middle">
                                                <a :href="getFileLink(file)" class="d-flex align-items-center"
                                                   target="_blank">
                                                    <i class="fa fa-file me-2"></i>
                                                    {{ file.name }}
                                                </a>
                                            </td>
                                            <td class="align-middle">
                                                {{ new Date(file.created_at).toLocaleDateString() }}
                                            </td>
                                            <td class="align-middle">
                                                <a :href="getFileLink(file)" class="btn btn-secondary btn-sm me-2" target="_blank">
                                                    View
                                                </a>
                                                <button class="btn btn-danger btn-sm" type="button"
                                                        @click="deleteFile(file)">
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </AdminBlock>
                        </template>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            :id="'create_' + getModalType() + 'contact_close_button'"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>

                    <button type="button" class="btn btn-primary" @click="createNewExpense" >
                        {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>

import axios from 'axios';
import VSelect from 'vue-select';
import { ref, computed, onMounted, watch, onUnmounted, useId } from 'vue';
import {errorAlert, successAlert} from "@/utils";
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import InputTextField from '@//components/movements/components/InputTextField.vue';
import DriverSelect from '@/components/movements/components/DriverSelect.vue';
import Modal from 'bootstrap/js/dist/modal';
import FileUpload from "@/components/movements/components/FileUpload.vue";
import MovementSelect from "@/components/movements/components/MovementSelect.vue";
import InputNumberField from "@//components/movements/components/InputNumberField.vue";

const props = defineProps({
    identifier: {
        type: String,
        default: '',
        required: false,
    },
    movements: {
        type: Array,
        default: () => [],
    },
    job: {
        type: Object,
        default: () => ({}),
    },
    expense: {
        type: Object,
        default: () => ({}),
    },
    modalFor: {
        type: String,
        default: '',
    }
})

const emit = defineEmits(['expense-created', 'file-deleted']);

const expenseLabel = ref('');
const reference = ref('');
const fuel = ref(null);

const evidenceReceived = ref(false);
const rechargeClient = ref(false);

const selectedMovement = ref(null);
const selectedDriver = ref(null);
const selectedPaymentMethod = ref('');

const price = ref(null);
const vat = ref(null);
const total = ref(null);

const modal = ref(null);

const fileUpload = ref(null);
const fileInternalSignatures = ref([]);

const evidenceReceivedId = useId() + '_evidence_received';
const rechargeClientId = useId() + '_recharge_client';

const isEdit = computed(() => {
    return !!(props.expense && Object.keys(props.expense).length > 0);
});

const getFileLink = (file) => {
    if (!file) {
        return '';
    }
    return route('movements.jobs.expenses.files.show', {file: file.id});
}

const getModalType = () => {
    return props.modalFor !== '' ? props.modalFor + '_' : '';
}

const getFileUploadRoute = () => {
    return route('api.movements.expenses.get-upload-url');
}

const handleFileUploaded = (signatures) => {
    fileInternalSignatures.value = signatures;
}

const createNewExpense = (e) => {

    if (!isEdit.value && (!fileInternalSignatures.value || fileInternalSignatures.value.length === 0)) {
        if (!confirm('Do you want to continue without adding photo evidence?')) {
            e.preventDefault();
            return;
        }
    }

    const data = {
        movement_id: selectedMovement.value?.id ?? null,
        driver_id: selectedDriver.value?.id ?? null,
        label: expenseLabel.value,

        payment_method: selectedPaymentMethod.value,

        evidence_received: evidenceReceived.value,
        recharge_client: rechargeClient.value,

        reference: reference.value || null,
        fuel: fuel.value || null,
        price: price.value || null,
        vat: vat.value || null,
        total: total.value || null,

        receipt_file_signature: fileInternalSignatures.value,
    };

    const url = isEdit.value
        ? route('api.movements.expenses.update', { expense: props.expense.id })
        : route('api.movements.expenses.store');

    const method = isEdit.value ? 'put' : 'post';

    axios[method]( url, data, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
        .then(response => {

            emit('expense-created', response.data.expense);

            fileUpload.value?.reset();
            fileInternalSignatures.value = [];

            successAlert(isEdit.value ? 'Expense Updated!' : 'Expense Created', 'Success');

            window.jQuery('.modal-header .btn-close').click();
        })
        .catch( errors => {
            const title = isEdit.value ? 'Error Updating Expense' : 'Error Creating Expense';
            errorAlert(errors, title);
        });
}

const updateDriver = (value) => {
    selectedDriver.value = value
}

const driverLink = computed(() => {
    return selectedDriver.value ? route('movements.drivers.show', { driver: selectedDriver.value.id }) : '#';
});

const compModalIdentifier = computed(() => {
    return props.identifier + '_expense_modal'
});

const deleteFile = (file) => {

    if (!confirm('Are you sure you want to delete this file?')) {
        return;
    }

    axios.delete(route('api.movements.expenses.files.destroy', {file: file.id}))
        .then((response) => {
            successAlert('File Deleted', 'Success');
            emit('file-deleted', response.data.expense);
        })
        .catch((error) => {
            errorAlert(error, "Error Deleting File");
        });
}

const files = computed(() => props.expense?.files ?? []);

watch(() => props.expense, (newExpense) => {
    expenseLabel.value = newExpense?.label || '';
    reference.value = newExpense?.reference || '';
    fuel.value = newExpense?.fuel || null;
    evidenceReceived.value = !!newExpense?.evidence_received || false;
    rechargeClient.value = !!newExpense?.recharge_client || false;
    selectedPaymentMethod.value = newExpense?.payment_method || '';
    price.value = newExpense?.price || null;
    vat.value = newExpense?.vat || null;
    total.value = newExpense?.total || null;
    selectedDriver.value = newExpense?.driver || null;
    selectedMovement.value = props.movements.find(movement => movement.id === newExpense?.movement_id ) || null;
}, { immediate: true });

onMounted(() => {
    modal.value = new Modal(document.getElementById(compModalIdentifier.value))
})

onUnmounted(() => {
    if (modal.value) {
        modal.value.dispose();
    }
});

</script>
